import { OnboardingStep } from '../../../../services/exports/Constants';

export default {
  [OnboardingStep.EmailVerification]: "Confirmer l'adresse e-mail",
  [OnboardingStep.StoreDetails]: 'Détails du magasin',
  [OnboardingStep.BusinessInfo]: "Détails de l'entreprise",
  // Outside Germany, where Store details and Business details are still one step.
  store_and_business_info: 'Ajouter les détails de votre boutique',
  [OnboardingStep.PersonalInfo]: 'Ajouter vos informations personnelles',
  // In Germany: the person who signs the contract, for a GmbH its managing director (Nishita).
  owner_personal_info: 'Informations personnelles du propriétaire',
  owner_personal_info_gmbh: 'Informations personnelles du propriétaire / gérant',
  [OnboardingStep.ShippingInfo]: 'Ajouter vos informations de livraison',
  [OnboardingStep.BankInfo]: 'Ajouter les coordonnées bancaires pour les versements',
  [OnboardingStep.TaxInfo]: 'Votre entreprise est-elle assujettie à la TVA ?',
  [OnboardingStep.BusinessDocs]: "Justificatif d'entreprise",
  [OnboardingStep.PersonalDocs]: "Justificatif d'identité",
  [OnboardingStep.InfoSubmission]: 'Recevoir un paiement',
  confirm_info_gateway: 'Recevoir un paiement – {{paymentGateway}}',
  [OnboardingStep.PaymentInfo]: 'Informations de paiement',
  [OnboardingStep.Subscription]: 'Abonnement',
  [OnboardingStep.MobileApp]: 'Application mobile',
  [OnboardingStep.DeliveryStructure]: 'Structure de livraison',
  [OnboardingStep.Contract]: 'Contrat',
  [OnboardingStep.ContractPayment]: 'Paiement du contrat',
  [OnboardingStep.Documents]: 'Téléverser les documents',
  [OnboardingStep.PromoCode]: 'Code promo',
};
